import { Injectable } from '@angular/core';

@Injectable()
export class AdDescListConfig {
  /**
   * å¸å±æ¹å¼
   */
  layout?: 'horizontal' | 'vertical' = 'horizontal';

  /**
   * åè¡¨é¡¹é´è·ï¼åä½ä¸º `px`
   */
  gutter?: number = 32;

  /**
   * åè¡¨åå·
   */
  size?: 'small' | 'large';
}
